// Session Manager to handle token expiration globally
import { TOKEN_KEY } from "../redux/action/api";

// Immediately logout user when token expires
export const triggerSessionExpiration = () => {
  // Clear authentication data
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("user");
  localStorage.removeItem("@@auth");

  // Show a brief message
  const message = "Your session has expired. Please login again.";

  // Redirect to login page
  window.location.href =
    "/login?session_expired=true&message=" + encodeURIComponent(message);
};

// Override fetch to intercept 401 responses
const originalFetch = window.fetch;
window.fetch = function (...args) {
  return originalFetch.apply(this, args).then((response) => {
    // Check if it's a 401 status - immediately logout
    if (response.status === 401) {
      triggerSessionExpiration();
      // Return a rejected promise to stop further processing
      return Promise.reject(new Error("Session expired"));
    }

    return response;
  });
};
